import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.6rem;
	padding: 0.8rem;
	background: var(--ticto-background);
	border-bottom: 1px solid var(--ticto-outline);

	p {
		margin: 0;
	}
`;

export const Fields = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 0.5rem;
`;

export const Field = styled.div<{ $wide?: boolean; $invalid: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	grid-column: ${({ $wide }) => ($wide ? '1 / -1' : 'auto')};

	label {
		font-size: 0.75rem;
		font-weight: 600;
		color: var(--ticto-title) !important;
	}

	input {
		height: 36px !important;
		padding: 0 10px !important;
		border-radius: 8px !important;
		border: 1px solid ${({ $invalid }) => ($invalid ? 'var(--ticto-red)' : 'var(--ticto-outline)')} !important;
		background: var(--ticto-shape) !important;
		color: var(--ticto-text) !important;
		font-size: 0.9rem !important;
		outline: 0 !important;
	}
`;

export const ErrorText = styled.small`
	color: var(--ticto-red) !important;
	font-weight: 500;
`;
